import React, { Component } from 'react';


class Subheader extends Component {

    constructor(props){
        super(props)
    }
    render() {
        var risktext
        if(this.props.content.length){
            risktext = this.props.content;
        }
        return(
            <div>
                <h3  style={{marginBottom:'16px'}}>{risktext}</h3>
            </div>
        )
    }
}

export default Subheader